import { render, staticRenderFns } from "./PromotionCodeDetailsPage.vue?vue&type=template&id=5eeff436&"
import script from "./PromotionCodeDetailsPage.vue?vue&type=script&lang=js&"
export * from "./PromotionCodeDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./PromotionCodeDetailsPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports